<section id="filterContainer">
    <article class="pl-5 pt-5">
        <h1 class="title">{{ literalService.get('filterBy', true) }}</h1>
    </article>
    <article class="lg:flex sm:relative pl-5 pt-5 pr-5 place-content-between">
        @if (clients.length > 1) {
            <label class="w-48 text-center title-columns mr-4">{{ literalService.get('messages.data.client', true) }}</label>
        }
        <label class="w-48 text-center title-columns mr-4">{{ literalService.get('suggestions.data.town', true) }} - {{ literalService.get('suggestions.data.service', true) }}</label>
        <label class="w-48 text-center title-columns mr-4">{{ literalService.get('suggestions.data.type', true) }}</label>
        <label class="w-48 text-center title-columns mr-4">{{ literalService.get('suggestions.data.priority', true) }}</label>
        <label class="w-48 text-center title-columns mr-4">{{ literalService.get('suggestions.data.status', true) }}</label>
    </article>
    <form #form novalidate>
        <article class="lg:flex sm:relative pl-5 pt-5 pr-5">
            @if (clients.length > 1) {
                <article class="lg:flex rounded w-48 items-start mr-4">
                    <app-multi-select-form [title]="'suggestion-clients'" [elements]="clients" [values]="selectedValuesClients" [width]="'48'" />
                </article>
            }
            <article class="mr-4">
                <article class="lg:flex rounded w-48 h-12 items-center mb-2">
                    <app-multi-select-form [title]="'suggestion-towns'" [elements]="towns" [values]="selectedValuesTowns" [width]="'48'" (closeEventEmitter)="onTownsClose()" />
                </article>
                <article class="lg:flex rounded w-48 items-center mb-2">
                    <app-input
                        class="w-48"
                        [data]="servicesElement"
                        [edit]="true"
                        [independent]="true"
                        (setEventEmitter)="onServicesChange($event.value)"
                        (scrollEventEmitter)="onScroll($event)"
                        (searchEventEmitter)="onSearch($event)"
                    />
                </article>
            </article>
            <article>
                @for (type of suggestionTypes; track $index) {
                    <label class="lg:flex box pt-2 pb-2 pl-4 pr-4 rounded w-48 h-12 mr-4 mb-2 items-center cursor-pointer bg-white">
                        <input type="checkbox" class="mr-2 cursor-pointer" [checked]="type.checked" (change)="type.checked = !type.checked" />
                        {{ literalService.get(`suggestions.${type.value.toLowerCase()}`, true) }}
                    </label>
                }
            </article>
            <article>
                @for (status of suggestionPriorities; track $index) {
                    <label class="lg:flex box pt-2 pb-2 pl-4 pr-4 rounded w-48 h-12 mr-4 mb-2 items-center cursor-pointer" [ngClass]="!closedStatusSelected ? 'bg-white' : 'bg-gray-100'">
                        <input type="checkbox" class="mr-2 cursor-pointer" [checked]="status.checked" (change)="status.checked = !status.checked" [disabled]="closedStatusSelected"/>
                        {{ literalService.get(`suggestions.priorities.${status.value.toLowerCase()}`, true) }}
                    </label>
                }
            </article>
            <article>
                @for (status of suggestionStatus; track $index) {
                    <label class="lg:flex box pt-2 pb-2 pl-4 pr-4 rounded w-48 h-12 mr-4 mb-2 items-center cursor-pointer" [ngClass]="!closedStatusSelected ? 'bg-white' : 'bg-gray-100'">
                        <input type="checkbox" class="mr-2 cursor-pointer" [checked]="status.checked" (change)="status.checked = !status.checked"/>
                        {{ literalService.get(`suggestions.statuses.${status.value.toLowerCase()}`, true) }}
                    </label>
                }
            </article>
        </article>
        <article class="pt-10 pl-5 pb-5">
            <article class="flex pt-5 place-content-between">
                <div class="flex">
                    <label class="lg:flex box pt-2 pb-2 pl-4 pr-4 rounded w-48 h-12 mr-4 mb-2 items-center cursor-pointer">
                        <input type="checkbox" class="mr-2 cursor-pointer" (change)="selectAll($event)" />
                        {{ literalService.get('selectAll', true) }}
                    </label>
                    <article class="lg:flex box pt-2 pb-2 pl-4 pr-4 rounded w-40 h-12 mr-4 mb-2 items-center cursor-pointer bg-white" (click)="clearSelection()">
                        <img [src]="images.trash" class="h-5 w-5 mr-2 cursor-pointer" alt="clearSelection" />
                        <label class="cursor-pointer hover:underline">{{ literalService.get('clearSelection', true) }}</label>
                    </article>
                </div>
                <article class="lg:flex box pt-2 pb-2 pl-4 pr-4 rounded w-48 h-12 mr-4 mb-2 items-center">
                    <input type="button" class="primary text-white gap-4 p-2 border-2 font-semibold h-12 w-48 uppercase cursor-pointer" [value]="literalService.get('filter', true)" (click)="onSubmit(); closeFilter.emit()" />
                </article>
            </article>
        </article>
    </form>
</section>

